import { motion } from "framer-motion";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useState } from "react";
import clsx from "clsx";
import { styled } from "@mui/material/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useSelector } from "react-redux";
import { selectCurrentLanguageId } from "app/store/i18nSlice";
import { useDispatch } from "react-redux";
import { t } from "app/store/labels/globalLabels";
import { Button, IconButton } from "@mui/material";

const container = {
  show: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  margin: 0,
  border: "none!important",
  borderRadius: "8px!important",
  marginBottom: 24,
  "&:before": {
    display: "none",
  },
  "&:first-of-type": {},
  "&:last-of-type": {
    marginBottom: 0,
  },
}));

const GuideList = (props) => {
  const { list, className } = props;
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(null);
  const lang = useSelector(selectCurrentLanguageId);

  const toggleAccordion = (panel) => (event, _expanded) => {
    setExpanded(_expanded ? panel : false);
  };

  const viewFile = async (guide) => {
    window.open(guide.content?.PDF?.src, "_blank");
  };

  const downloadFile = async (guide) => {
    const link = document.createElement("a");
    link.href = `${guide.content?.PDF?.src}?download`;
    link.click();
  };

  return (
    list.length > 0 && (
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className={clsx("", className)}
      >
        {list.map(
          (guide) =>
            Boolean(guide.is_active) && (
              <StyledAccordion
                component={motion.div}
                variants={item}
                key={guide.post_content_id}
                classes={{
                  root: "FaqPage-panel shadow",
                }}
                expanded={expanded === guide.post_content_id}
                onChange={toggleAccordion(guide.post_content_id)}
              >
                <AccordionSummary
                  expandIcon={
                    <FuseSvgIcon>heroicons-outline:chevron-down</FuseSvgIcon>
                  }
                >
                  <div className="flex items-center py-4">
                    <FuseSvgIcon color="action">
                      heroicons-outline:question-mark-circle
                    </FuseSvgIcon>
                    <Typography className="px-12 font-medium">
                      {guide.title_lang[lang]}
                    </Typography>
                  </div>
                </AccordionSummary>

                <AccordionDetails className="w-full flex flex-row items-center justify-center">
                  <div className="w-full flex flex-row items-center justify-center">
                    <Button
                      onClick={() => viewFile(guide)}
                      className="w-full flex flex-row items-center justify-center"
                    >
                      <FuseSvgIcon>material-solid:remove_red_eye</FuseSvgIcon>
                      <Typography className="text-14 px-32 ">
                        {dispatch(t("common.view"))}
                      </Typography>
                    </Button>
                  </div>

                  <div className="w-full flex flex-row items-center justify-center">
                    <Button
                      onClick={() => downloadFile(guide)}
                      className="w-full flex flex-row items-center justify-center"
                    >
                      <FuseSvgIcon>material-solid:cloud_download</FuseSvgIcon>
                      <Typography className="text-14 px-32 ">
                        {dispatch(t("common.download"))}
                      </Typography>
                    </Button>
                  </div>
                </AccordionDetails>
              </StyledAccordion>
            )
        )}
      </motion.div>
    )
  );
};

export default GuideList;
